const state = {
  nav: [
    {
      label: "Internet",
      feature: "internet",
      route: "internet"
    },
    {
      label: "Network Devices",
      feature: "network_devices",
      route: "network_devices"
    },
  ]
};
const getters = {
  siteUniteNav: state => state.nav
};

export default {
  state,
  getters
};